import { newsTicker } from "@/mocks/feed";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20illustration%20of%20slice%20of%20watermelon%20and%20fruit%20elements%20floating%20on%20soft%20cream%20and%20peach%20background%2C%20playful%20minimal%20editorial%20art%2C%20fresh%20young%20energetic%20mood%2C%20soft%20shadows%2C%20no%20text&width=1600&height=900&seq=hero-2026-melon&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50"></div>
      </div>

      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 pt-28 md:pt-36 pb-10 md:pb-14 text-center">
        <p className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50/80 px-4 py-1.5 text-xs md:text-sm text-foreground-700 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
          每日实时汇总 · 一个页面看遍全网热点
        </p>

        <h1 className="font-display mt-6 text-4xl leading-tight md:text-6xl text-foreground-950">
          吃瓜网上<span className="text-primary-600">·</span>今日热点
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base md:text-lg text-foreground-600">
          热门事件、焦点话题、新鲜猛料全网汇总。每天帮你把最热最新鲜的瓜端上桌，
          不用到处翻，轻松掌握今日吃瓜风向。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#hot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-fire-line" aria-hidden="true"></i>
            马上开瓜
          </a>
          <a
            href="#feeds"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50/70 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 backdrop-blur-sm transition-colors"
          >
            <i className="ri-list-check-2" aria-hidden="true"></i>
            浏览今日速递
          </a>
        </div>

        <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-3 gap-3 md:gap-4">
          {[
            { n: "1200+", l: "单日收录热点" },
            { n: "6 大类", l: "内容分类覆盖" },
            { n: "全天", l: "实时滚动追更" },
          ].map((s) => (
            <div key={s.l} className="rounded-2xl border border-background-200/70 bg-background-50/70 px-3 py-4 backdrop-blur-sm">
              <dd className="font-display text-2xl md:text-3xl text-primary-600">{s.n}</dd>
              <dt className="mt-1 text-xs text-foreground-600">{s.l}</dt>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-y border-background-200 bg-background-100/70">
        <div className="relative flex overflow-hidden py-2.5">
          <div className="flex shrink-0 animate-marquee items-center gap-10 pr-10">
            {[...newsTicker, ...newsTicker].map((n, i) => (
              <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                <i className="ri-chat-3-fill text-accent-500" aria-hidden="true"></i>
                {n}
              </span>
            ))}
          </div>
          <div className="flex shrink-0 animate-marquee items-center gap-10 pr-10" aria-hidden="true">
            {[...newsTicker, ...newsTicker].map((n, i) => (
              <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                <i className="ri-chat-3-fill text-accent-500" aria-hidden="true"></i>
                {n}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}